import { createContext, useState } from "react";
import { useAsyncFn, useEffectOnce } from "react-use";
import repository from "./SalaryCalculationRepository";
import SalaryCalculationForm from "./SalaryCalculationForm";
import { useDate } from "../../../utils/DateHelper";

export const SalaryCalculationContext = createContext();
const forms = {
  HOME: "HOME",
};
export const SalaryCalculationProvider = ({ children }) => {
  const [dataSource, setDataSource] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [data, setData] = useState();
  const [message, setMessage] = useState();
  const { formatDate } = useDate();

  useEffectOnce(async () => {
    let response = await repository.getAllEmployee();
    const employees = response;
    response = await repository.getAllPeriod();
    const periods = response.map((it) => {
      return {
        id: it.id,
        name: `${formatDate(it.date_from)} s/d ${formatDate(it.date_out)}`,
      };
    });

    setEmployees([{ id: "ALL", name: "SEMUA" }, ...employees]);
    setPeriods(periods);
    addNewTab(forms.HOME, SalaryCalculationForm);
  });

  //add new tab component
  const addNewTab = (title, component, data = null, mode = 1) => {
    const tabIndex = tabs.findIndex((it) => it.title === title);
    if (tabIndex >= 0) {
      setSelectedTabIndex(tabIndex);
      return;
    }
    setTabs([
      ...tabs,
      { title: title, Component: component, data: data, mode: mode },
    ]);
    setSelectedTabIndex(tabs.length);
  };

  //on process button click
  const [processState, process] = useAsyncFn(async (formData) => {
    const response = await repository.process(formData);
    setMessage(response.message);
    return response;
  }, []);

  return (
    <SalaryCalculationContext.Provider
      value={{
        forms,
        dataSource,
        setDataSource,
        setEmployees,
        employees,
        periods,
        setPeriods,
        data,
        setData,
        message,
        setMessage,
        tabs,
        setTabs,
        selectedTabIndex,
        setSelectedTabIndex,
        addNewTab,
        isConfirmDialogOpen,
        setIsConfirmDialogOpen,
        process,
        processState,
      }}
    >
      {children}
    </SalaryCalculationContext.Provider>
  );
};
